import {MaybeValidationError, ProcessFlowchartValidationError} from './ProcessFlowchartForValidationTypes';

export const pushErrors = (
  errors: Array<ProcessFlowchartValidationError>,
  errorOrErrors: MaybeValidationError | Array<ProcessFlowchartValidationError> | null
): Array<ProcessFlowchartValidationError> => {
  let newErrors = [...errors];
  if (errorOrErrors != null) {
    if (Array.isArray(errorOrErrors)) {
      for (const error of errorOrErrors) {
        newErrors = pushErrors(newErrors, error);
      }
    } else {
      newErrors = [...newErrors, errorOrErrors];
    }
  }
  return newErrors;
};
